import type { StyleMeetingSampleTemplate } from '../../gql';

import { randNumber } from '@ngneat/falso';

import { mockMeetingSampleSizeMapping } from './mockMeetingSampleSizeMapping';

/**
 * Returns a mocked StyleMeetingSampleTemplate (as returned by `findMeetingSampleTemplatesForStyles`)
 * with a single size mapping by default. Pass `sizeMapping: []` to represent a style with no real
 * template (which falls back to showing all sizes at quantity 0).
 */
const mockStyleMeetingSampleTemplate = (
    overwrite?: Partial<StyleMeetingSampleTemplate>
): StyleMeetingSampleTemplate => ({
    styleNumber: randNumber({ min: 12000000, max: 12999999 }),
    sizeMapping: [mockMeetingSampleSizeMapping()],
    ...overwrite,
    ['__typename']: 'StyleMeetingSampleTemplate',
});

export { mockStyleMeetingSampleTemplate };
